import { BasePlacement, Placement, Variation } from '@popperjs/core';

// eslint-disable-next-line import/prefer-default-export
export function getPlacement(align: Variation | 'center', position: BasePlacement): Placement {
  return align === 'center' ? position : `${position}-${align}`;
}
